import React from "react";
import {Alert, AlertTitle} from "@mui/material";

/**
 * LsAlert
 *
 * Props:
 * severity  "error"|"warning"|"info"|"success"  (default: "info")
 * title     string                               (optional)
 * compact   boolean                              (default: false)
 * ...rest   passed through to MUI Alert
 */
const LsAlert = ({severity = "info", title, children, compact = false, ...props}) => {
    return (
        <Alert
            severity={severity}
            {...props}
            sx={{
                fontSize: compact ? "0.7rem" : "0.8125rem",
                padding: compact ? "2px 8px" : "10px 12px",
                borderRadius: "6px",
                border: "1px solid",
                alignItems: "center",

                "&.MuiAlert-standardError": {
                    backgroundColor: "#FDECEA",
                    borderColor: "#C0393E",
                    color: "#6E181B",
                },
                "&.MuiAlert-standardWarning": {
                    backgroundColor: "#FEF3C7",
                    borderColor: "#D97706",
                    color: "#8A3E04",
                },
                "&.MuiAlert-standardInfo": {
                    backgroundColor: "#E8EEF8",
                    borderColor: "#2F5FA8",
                    color: "#0F2347",
                },
                "&.MuiAlert-standardSuccess": {
                    backgroundColor: "#E4F2EF",
                    borderColor: "#2A9986",
                    color: "#124840",
                },

                "& .MuiAlert-icon": {
                    padding: 0,
                    marginRight: compact ? "4px" : "10px",
                    opacity: 1,
                    alignItems: "center",
                    display: "flex",
                    "& svg": {fontSize: compact ? 14 : 18},
                },

                "& .MuiAlert-message": {
                    padding: 0,
                    display: "flex",
                    alignItems: "center",
                    overflow: "visible",
                    lineHeight: compact ? 1.1 : 1.4,
                },

                "& .MuiAlert-action": {
                    padding: 0,
                    paddingLeft: compact ? "4px" : "8px",
                    marginRight: 0,
                    alignItems: "center",
                    display: "flex",
                },

                "& .MuiAlertTitle-root": {
                    marginTop: 0,
                    marginBottom: compact ? "2px" : "4px",
                    fontSize: compact ? "0.75rem" : "0.875rem",
                    fontWeight: 600,
                },

                ...props.sx,
            }}
        >
            {title && <AlertTitle>{title}</AlertTitle>}
            {children}
        </Alert>
    );
};

export default LsAlert;